import { render, staticRenderFns } from "./photos.vue?vue&type=template&id=e1e7a504&scoped=true"
import script from "./photos.vue?vue&type=script&lang=js"
export * from "./photos.vue?vue&type=script&lang=js"
import style0 from "./photos.vue?vue&type=style&index=0&id=e1e7a504&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1e7a504",
  null
  
)

export default component.exports